import React, { Component } from 'react'
import shallowequal from 'shallowequal'
import { buildStyles } from 'components/Commons/Masonry/utils/style-helper'

const getPositionStyles = (rect, zIndex, rtl) => ({
  translateX: `${rtl ? -Math.round(rect.left) : Math.round(rect.left)}px`,
  translateY: `${Math.round(rect.top)}px`,
  // TODO FIX
  opacity: rect.height === 0 ? 0 : 1,
  zIndex,
})

export default class GridItem extends Component {
  constructor(props) {
    super(props)

    this.mounted = false
    this.node = null

    this.state = {
      ...getPositionStyles(props.rect, 1, props.rtl),
    }
  }

  componentDidMount() {
    this.mounted = true
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onMounted(this)
    this.startResizeObserver()
  }

  componentWillUnmount() {
    this.mounted = false
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onUnmount(this)
  }

  // When opted in, re-trigger the parent layout whenever this item's own height changes (e.g. its
  // content grew/shrank after mount). The base masonry only re-measures on prop/container changes,
  // so without this an in-place height change leaves cards overlapping until the next scroll/resize.
  startResizeObserver() {
    const { observeItemResize, onResize } = this.props
    if (this.resizeObserver || !observeItemResize || typeof ResizeObserver === 'undefined' || !this.node) return

    this.lastHeight = this.node.offsetHeight
    this.resizeObserver = new ResizeObserver(() => {
      if (!this.mounted || !this.node) return
      const height = this.node.offsetHeight
      // only react to height changes — width is driven by the layout itself, so ignoring it avoids loops
      if (height !== this.lastHeight) {
        this.lastHeight = height
        if (typeof onResize === 'function') onResize(this)
      }
    })
    this.resizeObserver.observe(this.node)
  }

  // TODO warning dont do that
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!shallowequal(nextProps, this.props)) {
      this.setStateIfNeeded({
        ...this.state,
        ...getPositionStyles(nextProps.rect, 2, nextProps.rtl),
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowequal(nextProps, this.props) || !shallowequal(nextState, this.state)
  }

  setStateIfNeeded(state) {
    if (this.mounted) {
      this.setState(state)
    }
  }

  render() {
    const {
      index,
      component: Element,
      containerSize,
      appearDelay,
      appear,
      appeared,
      enter,
      entered,
      leaved,
      onMounted,
      onUnmount,
      onResize,
      observeItemResize,
      itemKey,
      rect,
      duration,
      easing,
      units,
      vendorPrefix,
      userAgent,
      rtl,
      ...rest
    } = this.props

    const style = buildStyles(
      {
        ...this.state,
        display: 'block',
        position: 'absolute',
        top: 0,
        ...(rtl ? { right: 0 } : { left: 0 }),
        width: rect.width,
      },
      units,
      vendorPrefix,
      userAgent,
    )

    return <Element {...rest} ref={node => (this.node = node)} style={style} />
  }
}
